import { Component, OnInit } from "@angular/core";
import { ModalidadeGarantiaService } from "../../modalidade_garantia/modalidade-garantia.service";
import { OperacaoCreditoLivreDominioIndexador } from "src/app/model/operacao-credito-livre-dominio-indexador";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { MensagemService } from "../../mensagem.service";
import { DatePipe } from "@angular/common";
import { firstValueFrom } from "rxjs";
import { TarefasRemuneracaoService } from "./tarefas-remuneracao.service";
import { 
  EntradaRemuneracaoCentralDTO, EntradaRemuneracaoRepasseDTO, EntradaRemuneracaoCreditoLivreDTO, 
  RemuneracaoCreditoLivre, RemuneracaoRepasse, RemuneracaoCentral, RespostaRemuneracao 
} from "src/app/model/remuneracao.model";

@Component({
    selector: "app-tarefas-component",
    templateUrl: "./tarefas-remuneracao.component.html",
    styleUrls: ["./tarefas-remuneracao.component.scss"],
    standalone: false
})
export class TarefasRemuneracaoComponent implements OnInit {
  public indexadores: OperacaoCreditoLivreDominioIndexador[] = [];
  public dataUltimaCotacaoSelic: string;

  public credito: RemuneracaoCreditoLivre;
  public repasse: RemuneracaoRepasse;
  public central: RemuneracaoCentral;

  constructor(
    private modalidadeGarantiaService: ModalidadeGarantiaService,
    private loadingService: BnLoadingService,
    private tarefasRemuneracaoService: TarefasRemuneracaoService,
    private mensagemService: MensagemService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.credito = new RemuneracaoCreditoLivre();
    this.repasse = new RemuneracaoRepasse();
    this.central = new RemuneracaoCentral();

    this.buscarIndexadores();
    this.buscarDataUltimaCotacaoSelic();
  }

  async buscarIndexadores() {
    try {
      this.loadingService.bloqueiaTela();
      this.indexadores = await this.modalidadeGarantiaService
        .buscarIndexadores()
        .toPromise();
    } finally {
      this.loadingService.liberaTela();
    }
  }

buscarDataUltimaCotacaoSelic(): void {
  this.tarefasRemuneracaoService
    .buscarDataUltimaCotacaoSelicCarregada()
    .subscribe({
      next: (data: Date) => {
        this.dataUltimaCotacaoSelic =
          this.tranformarData(data, 'dd/MM/yyyy') || '';
      },
      error: (err) => {
        console.error(err);
        this.dataUltimaCotacaoSelic = '';
      }
    });
}

  get camposCreditoLivreNaoPreenchidos() {
    return (
      !this.credito.ideIndexadorAtualizacaoGarantia ||
      !this.credito.dataInicial ||
      !this.credito.dataFinal ||
      (this.credito.valorOperacao !== 0 && !this.credito.valorOperacao)
    );
  }

  get camposNaoPreenchidosCentral() {
    return (
      !this.central.ideOperacaoGarantida ||
      !this.central.dataInicioRemuneracao ||
      !this.central.dataFimRemuneracao ||
      (this.central.valorEmReaisASerRemunerado !== 0 && !this.central.valorEmReaisASerRemunerado)
    );
  }

  get camposNaoPreenchidosRepasse() {
    return (
      !this.repasse.numeroSistemaScc ||
      !this.repasse.numeroContratoScc ||
      !this.repasse.dataInicial ||
      !this.repasse.dataFinal ||
      (this.repasse.valorARemunerar !== 0 && !this.repasse.valorARemunerar)
    );
  }

  onIdOperacaoBlur(): void {
    if (!this.central.ideOperacaoGarantida) {
      return;
    }

   this.tarefasRemuneracaoService.buscarDescricaoTaxaAtualizacaoGarantia(this.central.ideOperacaoGarantida)
   .subscribe(descricao  => {
      this.central.descricaoTaxaAtualizacao = descricao.mensagem;
   });
  }

  async remunerarCreditoLivre() {
    try {
      if (this.camposCreditoLivreNaoPreenchidos) {
        this.mensagemService.adicionarMensagemErro(
          "Informe os campos obrigatórios"
        );
        return;
      }
      const dados: EntradaRemuneracaoCreditoLivreDTO = this.tratarInformacoesCredito();
      this.credito.resultado = await firstValueFrom(
        this.tarefasRemuneracaoService.remunerarCreditoLivre(dados)
      );
    } catch (err) {
      console.log(err);
      this.mensagemService.adicionarMensagemErro(
        "Houve um erro na hora de remunerar o valor"
      );
    }
  }

  remunerarRepasse() {
    if (this.camposNaoPreenchidosRepasse) {
      this.mensagemService.adicionarMensagemErro(
        "Informe os campos obrigatórios"
      );
      return;
    }

    const dadosRepasse = this.tratarInformacoesRepasse();

    this.tarefasRemuneracaoService.remunerarRepasse(dadosRepasse).subscribe({
      next: (resposta: RespostaRemuneracao) => {
        this.repasse.resultado = {
          valorRemunerado: Number(resposta.valorRemunerado),
          detalhesRemuneracao: resposta.detalhesRemuneracao
        };
      },
      error: err => {
        console.error(err);
      }
    });
  }

  async remunerarPorCentralRemuneracao() {
    try {
      if (this.camposNaoPreenchidosCentral) {
        this.mensagemService.adicionarMensagemErro(
          "Informe os campos obrigatórios"
        );
        return;
      }

      const remuneracaoDTO = this.tratarInformacoesCentral();      
     
      const { valorRemunerado } = await firstValueFrom(
      this.tarefasRemuneracaoService.remunerarPorCentralRemuneracao(remuneracaoDTO)
      );
       
      this.central.resultado = valorRemunerado;


    } catch (err) {
      console.log(err);
      this.mensagemService.adicionarMensagemErro(
        "Erro ao tentar remunerar o valor solicitado pela central de remuneracoes"
      );
    }
  }

  tratarInformacoesCredito(): EntradaRemuneracaoCreditoLivreDTO {
    return {
      ideIndexadorAtualizacaoGarantia: this.credito.ideIndexadorAtualizacaoGarantia,
      dataInicial: this.tranformarData(this.credito.dataInicial, "yyyyMMdd"),
      dataFinal: this.tranformarData(this.credito.dataFinal, "yyyyMMdd"),
      valorOperacao: this.credito.valorOperacao,
      valorTaxaAdicional: this.credito.valorTaxaAdicional,
    };
  }

  tratarInformacoesRepasse(): EntradaRemuneracaoRepasseDTO {
    return {
      dataInicial: this.tranformarData(this.repasse.dataInicial, "yyyyMMdd"),
      dataFinal: this.tranformarData(this.repasse.dataFinal, "yyyyMMdd"),
      valorARemunerar: this.repasse.valorARemunerar,
      numeroContratoScc: this.repasse.numeroContratoScc,
      numeroSistemaScc: this.repasse.numeroSistemaScc
    };
  }

  tratarInformacoesCentral(): EntradaRemuneracaoCentralDTO {
    return {
      ideOperacaoGarantida: this.central.ideOperacaoGarantida,
      valorEmReaisASerRemunerado: this.central.valorEmReaisASerRemunerado,
      dataInicioRemuneracao: this.tranformarData(this.central.dataInicioRemuneracao, "yyyy-MM-dd"),
      dataFimRemuneracao: this.tranformarData(this.central.dataFimRemuneracao, "yyyy-MM-dd"),
      remuneracaoPorFatores: this.central.remuneracaoPorFatores
    };
  }

  tranformarData(data: Date, formato: string): string {
    return this.datePipe.transform(data, formato);
  }

  limparCreditoLivre() {
    this.credito = new RemuneracaoCreditoLivre();
  }

  limparRepasse() {
    this.repasse = new RemuneracaoRepasse();
  }

  limparCentral() {
    this.central = new RemuneracaoCentral();
  }

  async habilitar() {
    try {
      this.tarefasRemuneracaoService.habilitar().subscribe(() => {
            this.mensagemService.adicionarMensagemSucesso("Remuneração habilitada.")
          })
    } catch (err) {
      console.log(err);
      this.mensagemService.adicionarMensagemErro(
        "Houve um erro ao habilitar a remuneração",
      );
    }
  }

  async desabilitar() {
    try {
      this.tarefasRemuneracaoService.desabilitar().subscribe(() => {
            this.mensagemService.adicionarMensagemSucesso("Remuneração desabilitada.")
          })
    } catch (err) {
      console.log(err);
      this.mensagemService.adicionarMensagemErro(
        "Houve um erro ao desabilitar a remuneração",
      );
    }
  }

  /////////////////////////////////////////////////////////////////////////
  //      SOLICITACAO DE REMUNERACAO
  /////////////////////////////////////////////////////////////////////////
  // JSON de exemplo para uso na API de tarefas - aplicavel apenas a testes em DSV/HOM
  private jsonSolic = `{
  "identificadorNegocio": "Teste Tarefa",
  "detalhes": [
    {
      "ideOperacaoGarantida": 598389,
      "valorEmReaisASerRemunerado": 10.0,
      "dataInicioRemuneracao": "2015-02-01",
      "dataFimRemuneracao": "2025-02-28"
    },
    {
      "ideOperacaoGarantida": 598389,
      "valorEmReaisASerRemunerado": 10.0,
      "dataInicioRemuneracao": "2015-01-01",
      "dataFimRemuneracao": "2025-02-28"
    },
    {
      "ideOperacaoGarantida": 598389,
      "valorEmReaisASerRemunerado": 10.0,
      "dataInicioRemuneracao": "2015-04-01",
      "dataFimRemuneracao": "2025-02-28"
    },
    {
      "ideOperacaoGarantida": 598389,
      "valorEmReaisASerRemunerado": 10.0,
      "dataInicioRemuneracao": "2015-03-01",
      "dataFimRemuneracao": "2025-02-28"
    }
  ]
}`;
  public limparJson() {
    this.jsonSolic = null;
  }
  public criarJson() {
      if (this.jsonSolic == null) {
        this.mensagemService.adicionarMensagemErro("Preencha o json", "Erro");
      } else {
        this.loadingService.bloqueiaTela();
        this.tarefasRemuneracaoService
          .criarSolicitacaoRemuneracaoPorJson(this.jsonSolic)
          .subscribe(
            () => {
              this.mensagemService.adicionarMensagemSucesso("Solicitação de Remuneração enviada.", "Sucesso");
              this.loadingService.liberaTela();
            },
            (error) => {
              this.loadingService.liberaTela();
            }
          );
      }
    }
  /////////////////////////////////////////////////////////////////////////
  //      SOLICITACAO DE REMUNERACAO
  /////////////////////////////////////////////////////////////////////////
}
